export const getDisplayName = (Component) => Component.displayName || Component.name || 'Component';

export default getDisplayName;



// WEBPACK FOOTER //
// ./src/common/utils/getDisplayName.js